import { render, staticRenderFns } from "./CargoSimpleUpload.vue?vue&type=template&id=7017032e&scoped=true&"
import script from "./CargoSimpleUpload.vue?vue&type=script&lang=js&"
export * from "./CargoSimpleUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7017032e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7017032e')) {
      api.createRecord('7017032e', component.options)
    } else {
      api.reload('7017032e', component.options)
    }
    module.hot.accept("./CargoSimpleUpload.vue?vue&type=template&id=7017032e&scoped=true&", function () {
      api.rerender('7017032e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoSimpleUpload.vue"
export default component.exports